<script lang="ts" setup>
import { GpTag } from '@gportal/uikit';
import { useVModel } from '@vueuse/core';
import Headline, { HeadlineType } from './Component.Headline.vue';

const props = withDefaults(
  defineProps<{
    img?: string;
    pretitle: string;
    title: string;
    subtitle?: string;
    badge?: string;

    isEditing?: boolean;
    isSubmittingTitle?: boolean;
    editable?: boolean;
  }>(),
  {
    img: undefined,
    subtitle: undefined,
    badge: undefined,

    isEditing: false,
    isSubmittingTitle: false,
    editable: false,
  },
);

const emit = defineEmits<{
  changedTitle: [string];
  'update:isEditing': [boolean];
}>();

const isEditingRef = useVModel(props, 'isEditing', emit);
const handleToggleEdit = (value: boolean) => {
  isEditingRef.value = value;
};

const changeCallback = (value: string) => {
  if (props.title !== value && value !== '') {
    emit('changedTitle', value);
  }
};
</script>

<template>
  <div class="tw-relative tw-flex tw-gap-6">
    <slot name="icon">
      <img
        v-if="img != null"
        :src="img"
        width="84"
        height="84"
        :alt="title"
        class="tw-block tw-size-[84px]"
      />
    </slot>
    <div class="tw-flex tw-flex-1 tw-flex-col tw-justify-center tw-overflow-hidden">
      <div class="tw-flex tw-items-center tw-gap-4">
        <strong
          class="tw-uppercase tw-tracking-wide tw-text-gp-rhino"
          v-playwright="'advanced-title-pretitle'"
        >
          {{ pretitle }}
        </strong>

        <slot name="badge">
          <GpTag
            v-if="badge"
            :label="badge"
            size="xs"
            tag-type="primary"
            outline
            class="tw-uppercase"
          />
        </slot>
      </div>
      <div class="tw-flex tw-items-center tw-gap-2">
        <Headline
          class="tw-flex-1"
          :is-editing="isEditingRef"
          :editable="editable"
          :type="HeadlineType.H1"
          :title="title"
          disable-upper
          :is-submitting-title="isSubmittingTitle"
          @value-changed="changeCallback"
          @toggle-edit="handleToggleEdit"
          data-testid="advanced-title-headline"
        >
          {{ title }}
        </Headline>

        <div>
          <slot name="actions"></slot>
        </div>
      </div>
      <slot name="subtitle">
        <small class="tw-text-sm" v-if="subtitle">{{ subtitle }}</small>
      </slot>
    </div>
  </div>
</template>
